import React, { useEffect, useState, useCallback } from "react";
import { View, Text, TouchableOpacity, Image, Keyboard } from "react-native";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { AppScreens } from "../../../Utility/AppScreens";
import { Base64 } from "js-base64";
import ChatConversation from "./ChatConversation";
import ChattingView from "./ChattingView";
import ContactModal from "./ContactModal";
import ChatSkeleton from "../../../../Components/skeleton-components/ChatSkeleton";
import { useChat } from "../../../../context/ChatContext";
import CommonTextInputWeb from "../../../../common/CommonTextInputWeb";
import { MobileDeviceNavigationHeader } from "../Common/MobileDeviceNavigationHeader";
import ChattingModal from "./ChattingModal";
import { getLoginData } from "../../../../utility/AppStoreData";
import Separator from "../../../../Components/Separator";
import Header from "../Common/Header";
import { ScreenBGGradientView } from "../../../../common/CommonView";

const Chat: React.FC = ({ route }: any) => {
  const {
    createChat,
    fetchUserChats,
    currentChat,
    loading,
    setUserData,
    userData,
    isChatVisible,
    setChatVisible,
    chats,
    setChats,
  } = useChat();
  const styles = useStyles();
  const navigation = useNavigation();
  const deviceSize = useDeviceSize();
  const [isContactVisible, setContactVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [originalChats, setOriginalChats] = useState([]);

  const decodeSessionAndCreateChat = async () => {
    try {
      const sessionEncoded = route?.params?.session;
      const sessionDecoded = Base64.decode(sessionEncoded);
      const sessionData = JSON.parse(sessionDecoded);

      const otherUsername = sessionData.username;
      const currentUsername = userData?.username;

      if (
        otherUsername &&
        currentUsername &&
        otherUsername !== currentUsername
      ) {
        await createChat("", [otherUsername], "single");
      }
    } catch (error) {
      console.error("Failed to decode session or create chat", error);
    }
  };

  useEffect(() => {
    const initializeChat = async () => {
      if (!userData) {
        const loginData = await getLoginData();
        if (loginData && loginData.AccessToken) {
          setUserData({
            accessToken: loginData.AccessToken,
            username: loginData.username,
          });
        }
      }

      if (userData?.accessToken) {
        if (route?.params?.session) {
          await decodeSessionAndCreateChat();
        } else {
          fetchUserChats(null);
        }
      }
    };

    initializeChat();
  }, [userData, route?.params?.session]);

  useEffect(() => {
    if (chats.length > 0 && originalChats.length === 0) {
      setOriginalChats(chats);
    }
  }, [chats]);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setChats(originalChats);
    } else {
      const query = searchQuery.toLowerCase();
      const filteredChats = originalChats.filter(
        (chat) =>
          chat.createdBy.toLowerCase().includes(query) ||
          chat.members.some((member) => member.toLowerCase().includes(query))
      );
      setChats(filteredChats);
    }
  }, [searchQuery, originalChats]);

  return (
    <>
      <ScreenBGGradientView />
      {/* {deviceSize === DEVICE_SIZES.XS && (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() =>
            navigateToScreen(navigation, AppScreens.NotificationScreen)
          }
          btnSettingTapped={() =>
            navigateToScreen(navigation, AppScreens.SettingWebScreen)
          }
          btnSearchTapped={() =>
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen)
          }
        />
      )} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <View style={styles.container}>
        {deviceSize !== DEVICE_SIZES.XS && (
          <>
            <View style={styles.separator} />
            <View style={styles.searchAddFriendsContainer}>
              {/* <View style={styles.searchView}>
                <Image
                  source={AppImages.icSearch}
                  style={styles.searchIcon}
                  resizeMode="contain"
                />
                <TextInput
                  placeholder="Search"
                  multiline={false}
                  placeholderTextColor={AppColors.white}
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    styles.textInputStyle,
                  ]}
                  keyboardType="default"
                  value={searchQuery}
                  onChangeText={setSearchQuery}
                />
              </View> */}
              {/* <CommonTextInputWeb
                placeholder="Username"
                mainStyle={[styles.inputStyle]}
                inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                prefixIconVisibility={false}
                onChangeText={setUsername}
                isPassword={false}
                value={username}
                onSubmitEditing={() => {
                  Keyboard.dismiss();
                }}
                autoCapitalize="none"
                maxLength={50}
              /> */}
              <View
                style={{
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  borderRadius: 12,
                  height: 48,
                  width: 280,
                }}
              >
                <CommonTextInputWeb
                  placeholder="Search"
                  mainStyle={[styles.textInputStyle]}
                  inputStyle={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { paddingVertical: 0, paddingHorizontal: 0 },
                  ]}
                  keyboardType="default"
                  value={searchQuery}
                  onChangeText={setSearchQuery}
                  prefixIconVisibility={true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  isPassword={false}
                  prefixIcon={AppImages.icSearchGray}
                  iconStyle={{ width: 24, height: 24 }}
                />
              </View>
              <TouchableOpacity
                onPress={() =>
                  navigateToScreen(navigation, AppScreens.AddFriends)
                }
                style={styles.addFriendsButton}
              >
                <View style={styles.addFriendIconWrapper}>
                  <Image
                    source={AppImages.icPlus}
                    style={styles.addFriendIcon}
                    resizeMode="contain"
                  />
                </View>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    styles.addFriendText,
                    {},
                  ]}
                >
                  Add Friends
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => setContactVisible(true)}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <View
                  style={{
                    height: 24,
                    width: 24,
                    borderRadius: 100,
                    backgroundColor: AppColors.appGreenColor_51AF07,
                  }}
                >
                  <Image
                    source={AppImages.icPlus}
                    style={{ tintColor: "black", height: 24, width: 24 }}
                    resizeMode="contain"
                  />
                </View>

                <Text style={[AppFontStyle.BOLD_ANYBODY_14, {}]}>
                  Create Group Chat
                </Text>
              </TouchableOpacity>
            </View>

            <Separator
              color={AppColors.gray_1E1E1E}
              height={1}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={20}
            />
          </>
        )}

        <View style={styles.chatHeader}>
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XL
                ? AppFontStyle.BOLD_ANYBODY_24
                : AppFontStyle.BOLD_ANYBODY_20,
            ]}
          >
            Chats
          </Text>
          {deviceSize === DEVICE_SIZES.XS && (
            <TouchableOpacity
              onPress={() =>
                navigateToScreen(navigation, AppScreens.AddFriends)
              }
              style={styles.addFriendsButton}
            >
              <View
                style={{
                  height: 24,
                  width: 24,
                  borderRadius: 100,
                  backgroundColor: AppColors.appGreenColor_51AF07,
                }}
              >
                <Image
                  source={AppImages.icPlus}
                  style={{ tintColor: "black", height: 24, width: 24 }}
                  resizeMode="contain"
                />
              </View>
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_12, styles.addFriendText]}
              >
                Add Friends
              </Text>
            </TouchableOpacity>
          )}
          {deviceSize === DEVICE_SIZES.XS && (
            <TouchableOpacity
              onPress={() => setContactVisible(true)}
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 3,
              }}
            >
              <View
                style={{
                  height: 24,
                  width: 24,
                  borderRadius: 100,
                  backgroundColor: AppColors.appGreenColor_51AF07,
                }}
              >
                <Image
                  source={AppImages.icPlus}
                  style={{ tintColor: "black", height: 24, width: 24 }}
                  resizeMode="contain"
                />
              </View>

              <Text style={[AppFontStyle.BOLD_ANYBODY_12, {}]}>
                Create Group Chat
              </Text>
            </TouchableOpacity>
          )}
        </View>

        {loading ? (
          <ChatSkeleton />
        ) : (
          <View style={styles.deviceFlexDirection}>
            <ChatConversation screenName="chat" />

            {deviceSize === DEVICE_SIZES.XS ? (
              isChatVisible && (
                <ChattingModal
                  chatID={currentChat?.conversationId}
                  selectedName={currentChat?.members.join(", ")}
                  isVisible={isChatVisible}
                  onClose={() => setChatVisible(false)}
                />
              )
            ) : (
              <View style={styles.chattingViewWrapper}>
                {currentChat && (
                  <ChattingView
                    currentItem={currentChat}
                    chatID={currentChat.conversationId}
                    selectedName={currentChat.members.join(", ")}
                  />
                )}
              </View>
            )}
            {isContactVisible && (
              <ContactModal
                isContactVisible={isContactVisible}
                onContactClose={() => setContactVisible(false)}
              />
            )}
          </View>
        )}
      </View>
    </>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "2%",
      paddingTop: "2.5%",
    },
    textInputStyle: {
      borderWidth: 0,
      borderColor: "transparent",
      paddingHorizontal: 15,
      paddingVertical: 10,
      flex: 1,
    },
    searchIcon: {
      height: 20,
      width: 20,
      alignSelf: "center",
      marginHorizontal: 5,
    },
    addFriendsButton: {
      flexDirection: "row",
      gap: 5,
    },
    addFriendIconWrapper: {
      height: 25,
      width: 25,
      borderRadius: 100,
      backgroundColor: AppColors.appGreenColor_51AF07,
      alignSelf: "center",
    },
    addFriendIcon: {
      tintColor: "black",
      height: 25,
      width: 25,
    },
    addFriendText: {
      alignSelf: "center",
    },
    separator: {
      height: 1,
      backgroundColor: AppColors.gray_1E1E1E,
      marginHorizontal: 20,
      marginTop: 20,
    },
    searchAddFriendsContainer: {
      marginHorizontal: 20,
      marginVertical: 10,
      flexDirection: "row",
      gap: 16,
    },
    chatHeader: {
      marginHorizontal: 20,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 15,
    },
    deviceFlexDirection: {
      flex: 1,
      flexDirection: "row",
    },
    chattingViewWrapper: {
      flex: 1,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      addFriendIconWrapper: {
        height: 25,
        width: 25,
        borderRadius: 100,
        backgroundColor: AppColors.appGreenColor_51AF07,
        alignSelf: "center",
        marginTop: 11,
      },
      addFriendText: {
        alignSelf: "center",
        marginTop: 0,
      },
      container: {
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      chatHeader: {
        marginHorizontal: 0,
      },
      addFriendsButton: {
        gap: 3,
      },
    },
    [DEVICE_SIZES.SM]: {
      addFriendIconWrapper: {
        height: 25,
        width: 25,
        borderRadius: 100,
        backgroundColor: AppColors.appGreenColor_51AF07,
        alignSelf: "center",
        marginTop: 11,
      },
      addFriendText: {
        alignSelf: "center",
        marginTop: 0,
      },
      container: {
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      chattingViewWrapper: {
        flex: 1,
        marginEnd: "0%",
      },
      chatHeader: {
        marginHorizontal: 0,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      chattingViewWrapper: {
        flex: 1,
        marginEnd: "0%",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      chattingViewWrapper: {
        flex: 1,
        marginEnd: "0%",
      },
    },
  }
);

export default Chat;
